import type { ComponentType, SVGProps } from 'react';

import {
    Activity,
    ArrowDown,
    ArrowLeftRight,
    ArrowUp,
    Bug,
    Building2,
    BulldozerIcon,
    Check,
    CheckIcon,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronRightIcon,
    ChevronUp,
    CircleCheckIcon,
    CircleIcon,
    Clock,
    Crosshair,
    Download,
    Eraser,
    ExportSceneIcon,
    ExportTrackIcon,
    ExportTrainIcon,
    Eye,
    Focus,
    Gauge,
    Github,
    GripHorizontal,
    Hash,
    Image,
    ImportSceneIcon,
    ImportTrackIcon,
    ImportTrainIcon,
    Info,
    InfoIcon,
    Landmark,
    Layers,
    Link2,
    List,
    ListOrdered,
    Loader2Icon,
    Map,
    MapPin,
    Merge,
    Mountain,
    MousePointer2,
    OctagonXIcon,
    Package,
    Pause,
    Pencil,
    Play,
    Plus,
    Scissors,
    Settings2,
    Snowflake,
    Spline,
    Sun,
    TrainFront,
    TrainTrack,
    Trash2,
    TriangleAlertIcon,
    Upload,
    Warehouse,
    X,
} from '@/assets/icons';

export type HandoffIconComponent = ComponentType<SVGProps<SVGSVGElement>>;

/**
 * Maps `exportName` (as used in code) to the live React icon for the handoff page.
 */
export const ICON_COMPONENTS: Record<string, HandoffIconComponent> = {
    Activity,
    ArrowDown,
    ArrowLeftRight,
    ArrowUp,
    Bug,
    Building2,
    BulldozerIcon,
    Check,
    CheckIcon,
    Clock,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronRightIcon,
    ChevronUp,
    CircleCheckIcon,
    CircleIcon,
    Crosshair,
    Download,
    Eraser,
    ExportSceneIcon,
    ExportTrackIcon,
    ExportTrainIcon,
    Eye,
    Focus,
    Gauge,
    Github,
    GripHorizontal,
    Hash,
    Image,
    ImportSceneIcon,
    ImportTrackIcon,
    ImportTrainIcon,
    Info,
    InfoIcon,
    Landmark,
    Layers,
    Link2,
    List,
    ListOrdered,
    Loader2Icon,
    Map,
    MapPin,
    Merge,
    Mountain,
    MousePointer2,
    OctagonXIcon,
    Package,
    Pause,
    Pencil,
    Play,
    Plus,
    Scissors,
    Settings2,
    Snowflake,
    Spline,
    Sun,
    TrainFront,
    TrainTrack,
    Trash2,
    TriangleAlertIcon,
    Upload,
    Warehouse,
    X,
};
